import { useMutation, useQueryClient } from '@tanstack/react-query';
import { post } from '@truefit/http-utils';
import useCurrentGameId from '@/shared/hooks/useCurrentGameId';
import type { EnrichedSportEvent } from '@c360/types';

interface CreateCustomEventInput {
  eventType: string;
  description: string;
  timestamp?: string;
  payload?: Record<string, any>;
  sourceNativeId?: string;
}

interface CreateCustomEventResponse {
  success: boolean;
  event: EnrichedSportEvent;
}

const useCreateCustomEventMutation = () => {
  const queryClient = useQueryClient();
  const gameId = useCurrentGameId();

  return useMutation({
    mutationFn: async (input: CreateCustomEventInput) => {
      const response = await post<CreateCustomEventResponse>(
        `/v1.0/games/${gameId}/custom-events`,
        input
      );
      return response.data.event;
    },
    onSuccess: () => {
      // Invalidate queries to refresh the events list
      queryClient.invalidateQueries({
        queryKey: ['Games', gameId, 'CustomEvents']
      });
      queryClient.invalidateQueries({
        queryKey: ['Games', gameId, 'PlayByPlay']
      });
    },
  });
};

export default useCreateCustomEventMutation;
